import { useMemo } from "react";
import { useMutation } from "@tanstack/react-query";

import useApi from "hooks/api";

import { createImportBalancesApi } from "../infrastructure/api/importBalances.api";
import { importBalancesMapper } from "../infrastructure/mappers/importBalances.mapper";
import { createImportBalancesRepository } from "../infrastructure/repositories/importBalances.repository";
import { importBalances } from "../application/useCases/importBalances";

type UseImportBalancesParamsT = {
  colaboraInstanceId?: string;
  typeId?: string;
  externalTypeId?: number;
};

export const useImportBalances = ({
  colaboraInstanceId,
  typeId,
  externalTypeId,
}: UseImportBalancesParamsT) => {
  const { genericApiCall } = useApi();

  const importBalancesRepository = useMemo(() => {
    const importBalancesApi = createImportBalancesApi(genericApiCall);
    return createImportBalancesRepository({ importBalancesApi, importBalancesMapper });
  }, [genericApiCall]);

  return useMutation({
    mutationFn: ({ mode }: { mode: "all" | "no-balances" }) =>
      importBalances({
        importBalancesRepository,
        colaboraInstanceId: colaboraInstanceId ?? "",
        typeId: typeId ?? "",
        mode,
        externalTypeId: externalTypeId ?? 0,
      }),
  });
};
